module.exports = __webpack_public_path__ + "img/c1.b8f85e1e.svg";